import {CustomError, IUcApi} from '../components/common/rootStore';

export function callSdkMethod(clazz: string, name: string ): (params: any) => Promise<any>{
  if (process.env.BROWSER) {
    return (params: any): Promise<any> => {
      // tslint:disable-next-line:no-shadowed-variable
      return new Promise<any>((resolve, reject) => {
        const ucapi = (window as any).ucapi as IUcApi;
        if (!ucapi) {
          reject(`ucapi undefined`);
        }
        if (ucapi[clazz] && ucapi[clazz][name]) {
          ucapi[clazz][name](Object.assign(params, {
            success: (result) => {
              resolve(result);
            },
            fail: (error) => {
              reject(error);
            },
          }));
        } else {
          reject(`${clazz}.${name} not found`);
        }
      });
    };
  } else {
    throw new CustomError('server side no jssdk', {});
  }
}
